import React, { useState } from "react";
import { FaUser, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import Swal from "sweetalert2";
import "./Login.css";

const API_BASE = "https://dgps.co.in/api";

export default function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const togglePasswordVisibility = () => setShowPassword((s) => !s);

  const handleLogin = async (e) => {
    e?.preventDefault?.();
    setError("");

    if (!/^\d{10}$/.test(mobile)) {
      setError("Enter a valid 10-digit mobile number.");
      return;
    }
    if (password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mobile, password }),
      });

      const data = await res.json().catch(() => ({}));
      console.log("data",data);
      if (!res.ok) throw new Error(data.message || `Request failed (${res.status})`);

      if (data.status) {
        // pick default school (only web roles are already filtered by backend)
        let chosenSchoolId = data.default_school_id;
        if (!chosenSchoolId && Array.isArray(data.schools) && data.schools.length) {
          chosenSchoolId = data.schools[0].id;
        }

        // after successful login
        localStorage.setItem("token", data.token);
        localStorage.setItem("id", data.user.id);
        localStorage.setItem("name", data.user.name);
        localStorage.setItem("schools", JSON.stringify(data.schools || []));
        localStorage.setItem("school_id", data.default_school_id || (data.schools[0] && data.schools[0].id) || "");
        const chosen = (data.schools || []).find(s => String(s.id) === String(data.default_school_id)) || (data.schools || [])[0];
        localStorage.setItem("role", chosen ? chosen.role : "");


       

        await Swal.fire({
          icon: "success",
          title: "Login Successful!",
          text: `Welcome, ${data.user.name}`,
          timer: 1400,
          showConfirmButton: true,
        });

        window.location.href = "/app/admin/dashboard";
      } else {
        throw new Error(data.message || "Invalid credentials.");
      }
    } catch (err) {
      console.error("Login Error:", err);
      setError(err.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form className="login-box" onSubmit={handleLogin}>
        <h2>🎓 School Portal Login</h2>
        <p className="subtitle">Access for Super Admin, Admin & Staff</p>

        {error && <p className="error-msg">{error}</p>}

        <div className="input-group">
          <FaUser className="icon" />
          <input
            type="text"
            placeholder="Mobile Number"
            value={mobile}
            maxLength={10}
            inputMode="numeric"
            onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
          />
        </div>

        <div className="input-group">
          <FaLock className="icon" />
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {showPassword ? (
            <FaEyeSlash className="toggle-eye" onClick={togglePasswordVisibility} />
          ) : (
            <FaEye className="toggle-eye" onClick={togglePasswordVisibility} />
          )}
        </div>

        <button className="login-btn" type="submit" disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
    </div>
  );
}
